import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const TelegramIcon: React.FC<CardGradientProps> = ({
  className,
  width = "1.74vw",
  height = "1.74vw",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.49917 11.8055C3.54281 11.7837 3.58646 11.763 3.629 11.7433C4.36858 11.4007 5.11798 11.0799 5.86629 10.7591C5.90665 10.7591 5.97427 10.7122 6.01245 10.6969C6.07026 10.6718 6.12808 10.6478 6.1859 10.6227C6.29716 10.5747 6.40843 10.5278 6.5186 10.4798C6.74113 10.3849 6.96256 10.2899 7.18509 10.195L8.51698 9.62432C9.40492 9.2446 10.294 8.86379 11.1819 8.48407C12.0698 8.10435 12.9588 7.72353 13.8468 7.34381C14.7347 6.96409 15.6237 6.58329 16.5117 6.20357C17.3996 5.82385 18.2886 5.44304 19.1766 5.06332C19.374 4.97821 19.5878 4.85163 19.7994 4.81453C19.9772 4.78289 20.1507 4.72179 20.3296 4.68796C20.6688 4.62358 21.043 4.5974 21.368 4.73815C21.4804 4.78726 21.584 4.856 21.6702 4.9422C22.0825 5.35029 22.0247 6.02025 21.9374 6.5942C21.3299 10.5944 20.7223 14.5956 20.1136 18.5958C20.0307 19.1446 19.9172 19.7469 19.4842 20.0939C19.1177 20.3874 18.5962 20.4202 18.1435 20.2958C17.6909 20.1703 17.2916 19.9073 16.9 19.6487C15.2758 18.5728 13.6504 17.497 12.0262 16.4211C11.64 16.1658 11.2103 15.8319 11.2146 15.3681C11.2168 15.0888 11.3837 14.84 11.5539 14.6185C12.9654 12.7767 15.002 11.5109 16.5171 9.75417C16.7309 9.50648 16.8989 9.05911 16.6055 8.91616C16.431 8.83106 16.2302 8.94671 16.071 9.05692C14.0682 10.4481 12.0666 11.8404 10.0638 13.2317C9.41039 13.6856 8.72535 14.1526 7.93777 14.2639C7.2331 14.3643 6.52406 14.1679 5.8423 13.9671C5.2707 13.7991 4.70018 13.6267 4.13186 13.4488C3.8297 13.355 3.51772 13.2535 3.28428 13.0407C3.05085 12.8279 2.91669 12.47 3.05741 12.1863C3.14577 12.0085 3.31703 11.8961 3.49702 11.8044L3.49917 11.8055Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TelegramIcon;
